import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ClickOutsideModule } from 'ng-click-outside';
import { AutoCompleteSearchV3Component } from './auto-complete-search-v3.component';
import { AutoCompleteV3Service } from './auto-complete-v3.service';
import { AcsListItemV3Component } from './components/acs-list-item-v3/acs-list-item-v3.component';
import { DaLinkModule } from '../da-link/da-link.module';
import { DaButtonModule } from '../da-button/da-button.module';
import { PipesModule } from '@draeger-academy/common';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { AppInfoService } from '@draeger-academy/common/lib/services/app-info/app-info.service';

@NgModule({
    declarations: [AutoCompleteSearchV3Component, AcsListItemV3Component],
    imports: [
        CommonModule,
        FormsModule,
        ClickOutsideModule,
        DaLinkModule,
        DaButtonModule,
        PipesModule,
        TranslateModule.forChild(),
        LocalizeRouterModule.forChild([])
    ],
    providers: [AutoCompleteV3Service, AppInfoService],
    exports: [AutoCompleteSearchV3Component, AcsListItemV3Component]
})
export class AutoCompleteSearchV3Module {}
